import React, { useState } from 'react';
// @Mui
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import LoginIcon from '@mui/icons-material/Login';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {
  Dialog,
  Divider,
  Paper,
  Slide,
  Typography,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// eslint-disable-next-line import/no-unresolved
import { ConnectKitButton } from 'connectkit';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useWeb3Modal } from '@web3modal/react';
import { Box } from '@mui/system';
import { useAccount, useConnect } from 'wagmi';
import { useLocation, Link } from 'react-router-dom';
import { SideBarData } from '../../utils/components-data';

// ----------------------------------------------------------------------

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BottomNav = () => {
  // eslint-disable-next-line no-unused-vars
  const [value, setValue] = useState(0);
  const { isConnected } = useAccount();
  const { connectors, connect } = useConnect();
  const { pathname } = useLocation();
  const theme = useTheme();
  const { isOpen, open: openModal, close } = useWeb3Modal();

  // Dialog
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.modal - 1,
      }}
      elevation={3}
    >
      <BottomNavigation
        sx={{ bgcolor: 'grey.900' }}
        showLabels
        value={pathname}
        onChange={(e, newVal) => {
          setValue(newVal);
        }}
      >
        {SideBarData.slice(0, 2).map(({ icon, id, name, path }) => (
          <BottomNavigationAction
            sx={{ whiteSpace: 'nowrap' }}
            component={Link}
            to={path}
            value={path}
            key={id}
            label={name}
            icon={<Box>{icon}</Box>}
          />
        ))}
        <BottomNavigationAction
          label={isConnected ? 'logout' : 'login'}
          icon={
            <ConnectKitButton.Custom>
              {({ isConnected, show }) => (
                <Box onClick={!isConnected ? () => openModal() : show}>
                  {isConnected ? <AccountBoxIcon /> : <LoginIcon />}
                </Box>
              )}
            </ConnectKitButton.Custom>
          }
        />
        <BottomNavigationAction
          onClick={handleClickOpen}
          id="more-button"
          label={'more'}
          icon={<MoreHorizIcon />}
        />
      </BottomNavigation>
      <Dialog
        fullScreen
        sx={{ zIndex: 999999999, '.MuiDialog-paper': { margin: 0 } }}
        id="navigation-dialog"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Box
          onClick={handleClose}
          sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', mr: 2 }}
        >
          <CloseIcon />
        </Box>
        <Divider sx={{ my: 2, bgcolor: 'grey.900' }} />
        <Box
          sx={{
            my: 2,
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1.5,
          }}
        >
          {SideBarData.slice(2, SideBarData.length).map(
            ({ icon, id, name, path }) => (
              <Typography
                variant="h6"
                onClick={handleClose}
                key={id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  columnGap: 0.5,
                  color: path === pathname ? 'primary.main' : '#fff',
                  textDecoration: 'none',
                  bgcolor: 'grey.900',
                  py: 1,
                  borderRadius: 3,
                }}
                component={Link}
                to={path}
              >
                <span>{name}</span>
                {icon}
              </Typography>
            )
          )}
        </Box>
      </Dialog>
    </Paper>
  );
};

export default BottomNav;
